"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _icons = require("@material-ui/icons");

var _Button = _interopRequireDefault(require("../Buttons/Button"));

var _SortedLogoWithName = _interopRequireDefault(require("../../assets/logos/SortedLogoWithName"));

var _constants = require("../../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const SortedLogo = _styledComponents.default.div`
	width: 120px;

	@media (min-width: ${_constants.breakpoints.tablet}) {
		width: 180px;
	}
`;
const Shout = _styledComponents.default.div`
	font-family: 'Anton Regular', sans-serif;
	font-size: 100px;
`;
const Heading = _styledComponents.default.h1`
	font-size: 32px;
`;
const Content = _styledComponents.default.div`
	font-size: 19px;
`;
const Section = _styledComponents.default.section`
	max-width: 360px;
`;

const doAction = action => {
  switch (action) {
    case 'back':
      {
        window.history.go(-1);
        return;
      }

    default:
      {
        window.location.reload();
      }
  }
};

const ErrorPanel = ({
  shout,
  heading,
  children,
  action
}) => /*#__PURE__*/_react.default.createElement(Section, null, /*#__PURE__*/_react.default.createElement(SortedLogo, null, /*#__PURE__*/_react.default.createElement(_SortedLogoWithName.default, null)), /*#__PURE__*/_react.default.createElement(Shout, null, shout), /*#__PURE__*/_react.default.createElement(Heading, null, heading), /*#__PURE__*/_react.default.createElement(Content, null, children), action !== 'none' && /*#__PURE__*/_react.default.createElement(_Button.default, {
  variant: "contained",
  startIcon: action === 'back' ? /*#__PURE__*/_react.default.createElement(_icons.ArrowBack, null) : /*#__PURE__*/_react.default.createElement(_icons.Refresh, null),
  onClick: () => doAction(action)
}, action === 'back' ? 'Back' : 'Refresh'));

ErrorPanel.propTypes = {
  shout: _propTypes.default.string,
  heading: _propTypes.default.string.isRequired,
  children: _propTypes.default.node.isRequired,
  action: _propTypes.default.oneOf(['back', 'reload', 'none'])
};
ErrorPanel.defaultProps = {
  shout: 'Oops!',
  action: 'none'
};
var _default = ErrorPanel;
exports.default = _default;